import { type KeyPrefix, type TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { NAMESPACE } from '@/config/i18n/i18n.constants.ts';

export const useTranslationWithPrefix = (
  prefix: KeyPrefix<typeof NAMESPACE>,
): ReturnType<typeof useTranslation<typeof NAMESPACE, KeyPrefix<typeof NAMESPACE>>> => {
  return useTranslation(NAMESPACE, { keyPrefix: prefix });
};

export type PrivalleyTFunction = TFunction<typeof NAMESPACE, KeyPrefix<typeof NAMESPACE>>;
